import moment from 'moment'

const dateMixin = {
  methods: {
    stringToDate (stringDate, format) {
      return moment(stringDate, format)
    },
    formatDateTime (date) {
      return moment(date).format('DD/MM/YYYY h:mm a')
    },
    formatDate (date, dateFormat) {
      return dateFormat ? moment(date, dateFormat).format('DD/MM/YYYY') : moment(date).format('DD/MM/YYYY')
    },
    formatISOString (stringDate, days = 0, months = 0, years = 0) {
      let date = moment(stringDate)

      if (days !== 0) {
        date = date.add(days, 'd')
      }

      if (months !== 0) {
        date = date.add(months, 'M')
      }

      if (years !== 0) {
        date = date.add(years, 'y')
      }

      return moment(date).format('YYYY-MM-DD').toString()
    },
    formatDBDateTimeString (date) {
      return moment(date).format('YYYY-MM-DD hh:mm:ss').toString()
    }
  }
}
export default dateMixin
